module.exports = __webpack_public_path__ + "img/mds.47d17c93.svg";